import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { deleteEventLog } from "../../../axios/Eventlog/EventLogApi";
import ConfirmActionDialog from "../../../components/ConfirmActionDialog";

const RemoveEventDialog = ({ onClose, onRefresh, info }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleCloseDialog = () => {
    if (loading) return;
    onClose();
  };

  const handleRemoveEventLog = async () => {
    setLoading(true);
    try {
      const payload = {
        eventAttendanceId: info.eventAttendanceId,
        langId: localStorage.getItem("i18nextLngId"),
      };
      const response = await deleteEventLog(payload);

      if (response?.data === "") {
        onClose();
        toast.success(t("common.content-166"));
        onRefresh?.();
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status !== 401) {
          toast.error(t(error?.response.data));
        }
      } else {
        toast.error(t("common.network-timeout"));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmActionDialog
      open
      variant="delete"
      title={t("common.content-164")}
      subtitle={t("common.content-165")}
      confirmText={t("button.delete")}
      loading={loading}
      onClose={handleCloseDialog}
      onConfirm={handleRemoveEventLog}
    />
  );
};

export default RemoveEventDialog;
